<div class="modal-header" appCustomAutofocus>
    <h3>Plan Attachment(s)</h3>
</div>
<div class="modal-body">
    {{plan.PlanName}}<br />
    <div *ngIf="loading">
        <div style="text-align: center;">
            <img style="margin-bottom:10px;" id="loader" src="/Cache/images/icon_load.gif" /><br />
        </div>
        <label>Please wait while your attachments load...</label>
    </div>
    <ul *ngIf="!loading">
        <li *ngFor="let attachment of PlanAttachments[plan.BenefitCode]">
            <a target="_blank" href="/Document/GetVPAttachment?attachmentID={{attachment.AttachmentID}}">
                {{attachment.AttachName}}
            </a>
        </li>
    </ul>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="closeClicked()">Close</button>
</div>
